import axios from "axios";
import { useEffect, useState } from "react";

import { useLanguage } from "../../../context/LanguageProvider";
import { getBlogs } from "../api/blogApi";
import type { BlogSummary } from "../types";

// Loads one page of posts. Reloads when the page OR the language changes.
export const useBlogs = (page: number) => {
    const { lang } = useLanguage();

    const [blogs, setBlogs] = useState<BlogSummary[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const controller = new AbortController();

        setLoading(true);
        setError(false);

        getBlogs(lang, page, controller.signal)
            .then((result) => {
                setBlogs(result.blogs);
                setTotalPages(result.totalPages);
            })
            .catch((err) => {
                if (axios.isCancel(err)) return; // Page was left: not a real error
                console.error("Error fetching blogs:", err);
                setBlogs([]);
                setTotalPages(0);
                setError(true);
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [lang, page]);

    return { blogs, totalPages, loading, error };
};